import React from 'react';
import SignInContainer from './container';

const SignIn = props => <SignInContainer {...props} />;

export default SignIn;
